import { useMutation, useQueryClient } from "react-query";
import { api } from "../../utils/api/api";

const deleteScholarshipAppDoc = async (
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError,
  values
) => {
  try {
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarship_application_protected_api/removeAppDoc`,
      {
        scholarshipApplicationDocsId: values.scholarship_application_docs_id,
        scholarshipId,
      },
      { token }
    );

    return response;
  } catch (err) {
    if (err?.httpStatus === 401) {
      handleInvalidToken();
    } else if (err?.httpStatus === 500) {
      handleAPIError();
    }
    throw new Error(err);
  }
};

export function useDeleteScholarshipAppDoc(
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError
) {
  const queryClient = useQueryClient();

  return useMutation(
    (values) => {
      return deleteScholarshipAppDoc(
        scholarshipId,
        token,
        handleInvalidToken,
        handleAPIError,
        values
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("scholarshipApp");
      },
      retry: 3,
    }
  );
}
